import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';
import { addEventListener } from '@ifeng-fe/ui_base';
import { formatImage } from 'ThreeTerminal_base/publicMethod';

/**
 * 定义 Title 组件
 */
class Title extends React.PureComponent {
    static propTypes = {
        content: PropTypes.array,
        func: PropTypes.object,
    };

    componentDidMount() {
        const { changePage } = this.props.func;

        this.unhashchange = addEventListener(window, 'hashchange', changePage);
        changePage();
    }

    componentWillUnmount() {
        this.unhashchange();
    }

    /**
     * 渲染组件
     */
    render() {
        const {
            content,
            func: { clickToShowSlide },
        } = this.props;
        // @TODO裁图

        return (
            <div className={styles.moreList}>
                <ul className={styles.ulList}>
                    {content.map((item, index) => (
                        <li key={index}>
                            <a href={`#p=${index + 1}`} onClick={clickToShowSlide}>
                                <img
                                    title={item.description}
                                    width="165"
                                    height="109"
                                    src={formatImage(item.url, 165, 109)}
                                />
                            </a>
                        </li>
                    ))}
                </ul>
            </div>
        );
    }
}

export default errorBoundary(Title);
